import * as React from "react";
const SvgFiRrHandSpock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-spock_svg__a)">
      <path
        fill="#062147"
        d="M23.254 2.027c-.579-.664-1.439-1.004-2.313-1.027a2.85 2.85 0 0 0-1.37.376A2.98 2.98 0 0 0 17.45.027a3 3 0 0 0-3.37 2.562l-.46 3.141-1.245-3.69A2.98 2.98 0 0 0 10.862.311a2.997 2.997 0 0 0-4.185 1.772 2.8 2.8 0 0 0-.889-.075 3.01 3.01 0 0 0-2.213 1.229c-.519.713-.697 1.614-.472 2.533l2.303 7.378-.36-.34c-.585-.546-1.326-.844-2.147-.806-.8.027-1.54.364-2.088.949a3.004 3.004 0 0 0 .13 4.231l4.456 4.297A8.96 8.96 0 0 0 11.644 24h4.475a6.02 6.02 0 0 0 5.948-5.214l1.896-14.342a3 3 0 0 0-.707-2.417zm-1.273 2.138-1.897 14.358a4.01 4.01 0 0 1-3.966 3.476h-4.475a6.97 6.97 0 0 1-4.858-1.96l-4.467-4.307a1.005 1.005 0 0 1-.047-1.417 1 1 0 0 1 1.405-.051l3.138 2.962a1 1 0 0 0 1.641-1.025L5.03 5.236a1 1 0 0 1 .911-1.235c.396-.03.794.242.981.647l1.91 5.669a1 1 0 1 0 1.894-.639L8.582 3.319a1 1 0 0 1 1.895-.642l2.575 7.64c.147.439.582.716 1.037.677a1 1 0 0 0 .9-.851l1.067-7.278a1.001 1.001 0 0 1 1.785-.474.98.98 0 0 1 .2.722l-1.03 6.733a1 1 0 0 0 .837 1.139.99.99 0 0 0 1.14-.837s.983-6.078 1-6.192c.08-.532.51-.953.977-.959.324 0 .585.118.78.342.194.222.28.516.234.823z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-spock_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandSpock;
